import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-internal',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './internal.component.html',
  styleUrl: './internal.component.scss',
})
export class InternalComponent {}
